module.exports = __webpack_public_path__ + "static/media/right-scroll.07b8ab7b.svg";